import { useEffect, useState } from "react";
import { createClient } from "@/utils/supabase/client";

import { Database } from "@/types/supabase";

type Profile = Database["public"]["Tables"]["profiles"]["Row"];

export function useProfile(userId: string | undefined) {
  const [profile, setProfile] = useState<Profile | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const supabase = createClient();

  useEffect(() => {
    async function fetchProfile() {
      if (!userId) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const { data, error } = await supabase
          .from("profiles")
          .select("*")
          .eq("id", userId)
          .single();

        if (error) throw error;
        setProfile(data);
      } catch (e) {
        setError(
          e instanceof Error ? e : new Error("An unknown error occurred"),
        );
      } finally {
        setIsLoading(false);
      }
    }

    fetchProfile();
  }, [userId]);

  return { profile, isLoading, error };
}
